import { useTranslation } from "react-i18next";

import { LockIcon } from "@lucide/icons";

import { H3, Subheader } from "simplydo/react/ui/header";
import { Icon } from "simplydo/react/ui/icon";

import { useAppSelector } from "store";

import { MfaSettingsSection } from "../Mfa/MfaSettingsSection";

const EnforceMFA = () => {
  const { t } = useTranslation();
  const user = useAppSelector((state) => state.user);

  return (
    <>
      <H3>
        <Icon icon={LockIcon} />
        {t("entry.mfa.title")} {t("generic.required")}
        <Subheader>
          <p>
            {t("entry.mfa.requiredByOrg", {
              orgName: user?.ownerOrganisation?.name,
            })}
          </p>
          <p>{t("entry.mfa.enforcementInfo")}</p>
        </Subheader>
      </H3>

      <MfaSettingsSection mfaEnforced />
    </>
  );
};

export default EnforceMFA;
